import * as React from 'react'

function SvgDownload(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 30 30" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.56 11.94l3.94 3.939V3.5a1.5 1.5 0 013 0v12.379l3.94-3.94a1.5 1.5 0 012.12 2.122l-6.5 6.5a1.495 1.495 0 01-1.607.336 1.496 1.496 0 01-.514-.336l-.007-.008-6.493-6.492a1.5 1.5 0 112.122-2.122zM5 20.5a1.5 1.5 0 00-3 0V26a2 2 0 002 2h22a2 2 0 002-2v-5.5a1.5 1.5 0 00-3 0V25H5v-4.5z"
        fill="currentColor"
      />
    </svg>
  )
}

export default SvgDownload
